import { useState } from "react";
import { BookOneLesson } from "../booking/BookOneLesson.js";
import { Drawer } from "../ui/Dialog.js";

export function AddAppointmentDrawer({ canChooseTutor, onClose, onBooked }: {
  /** Owners pick the tutor; everyone else books into their own diary. */
  canChooseTutor: boolean;
  onClose: () => void;
  onBooked: () => void;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <Drawer
      eyebrow="Diary"
      title="Add appointment"
      description={canChooseTutor
        ? "Choose a tutor, student and lesson type, then pick an available time."
        : "Choose a student and lesson type, then pick an available time."}
      onClose={onClose}
      busy={busy}
      closeLabel="Close add appointment"
      className="cal-lesson-drawer cal-booking-drawer"
      size="wide"
    >
      <div className="cal-booking-drawer-body">
        <BookOneLesson appointmentMode onBooked={onBooked} onMutationBusyChange={setBusy} />
      </div>
    </Drawer>
  );
}
